import axios from 'axios';
import { localStorage as localStorageConstants } from 'constants/index';
import * as qs from 'qs';
import { push } from 'connected-react-router';
import { normalizeMyTagData, transformCategoryToTags } from 'utils/manipulate';
import resolvePath from 'utils/resolvePath';
import { store } from 'store/store';
// Action
const FORWARD = 'students/forward';
const BACK = 'students/back';
const REGISTER = 'students/register';
const PHONE_REGISTER = 'students/phoneRegister';
const RESET_INFO = 'students/resetInfo';
const CLEAR_ERROR = 'students/clearError';
const CLEAR_OTHER_USER = 'students/clearOtherUser';
const GET_TAGS_REQUEST = 'students/getTagsRequest';
const GET_TAGS_SUCCESS = 'students/getTagsSuccess';
const GET_TAGS_FAILURE = 'students/getTagsFailure';
const GET_PURPOSES_REQUEST = 'students/getPurposesRequest';
const GET_PURPOSES_SUCCESS = 'students/getPurposesSuccess';
const GET_PURPOSES_FAILURE = 'students/getPurposesFailure';
const POST_ME_REQUEST = 'students/postMeRequest';
const POST_ME_SUCCESS = 'students/postMeSuccess';
const POST_ME_FAILURE = 'students/postMeFailure';
const POST_SIGNIN_REQUEST = 'students/postSigninRequest';
const POST_SIGNIN_SUCCESS = 'students/postSigninSuccess';
const POST_SIGNIN_FAILURE = 'students/postSigninFailure';
const GET_ME_REQUEST = 'students/getMeRequest';
const GET_ME_SUCCESS = 'students/getMeSuccess';
const GET_ME_FAILURE = 'students/getMeFailure';
const GET_PK_REQUEST = 'students/getPkRequest';
const GET_PK_SUCCESS = 'students/getPkSuccess';
const GET_PK_FAILURE = 'students/getPkFailure';
const GET_PACKAGES_REQUEST = 'students/getPackagesRequest';
const GET_PACKAGES_SUCCESS = 'students/getPackagesSuccess';
const GET_PACKAGES_FAILURE = 'students/getPackagesFailure';
const PATCH_ME_REQUEST = 'students/patchMeRequest';
const PATCH_ME_SUCCESS = 'students/patchMeSuccess';
const PATCH_ME_FAILURE = 'students/patchMeFailure';
const POST_PHONE_AUTHENTICATION_REQUEST = 'students/postPhoneAuthenticationRequest';
const POST_PHONE_AUTHENTICATION_SUCCESS = 'students/postPhoneAuthenticationSuccess';
const POST_PHONE_CODE_VALIDATION_REQUEST = 'students/postPhoneCodeValidationRequest';
const POST_PHONE_CODE_VALIDATION_SUCCESS = 'students/postPhoneCodeValidationSuccess';
const POST_VALIDATE_REQUEST = 'students/postValidateRequest';
const POST_VALIDATE_SUCCESS = 'students/postValidateSuccess';
const POST_VALIDATE_FAILURE = 'students/postValidateFailure';
const DELETE_SIGNOUT_REQUEST = 'students/deleteSignoutRequest';
const DELETE_SIGNOUT_SUCCESS = 'students/deleteSignoutSuccess';
const DELETE_SIGNOUT_FAILURE = 'students/deleteSignoutFailure';
const POST_PASSWORD_REQUEST = 'students/postPasswordRequest';
const POST_PASSWORD_SUCCESS = 'students/postPasswordSuccess';
const POST_PASSWORD_FAILURE = 'students/postPasswordFailure';
const POST_ISSUE_REQUEST = 'students/postIssueRequest';
const POST_ISSUE_SUCCESS = 'students/postIssueSuccess';
const POST_ISSUE_FAILURE = 'students/postIssueFailure';
const PATCH_PASSWORD_REQUEST = 'students/patchPasswordRequest';
const PATCH_PASSWORD_SUCCESS = 'students/patchPasswordSuccess';
const PATCH_PASSWORD_FAILURE = 'students/patchPasswordFailure';
const GET_STUDENT_REQUEST = 'students/getStudentRequest';
const GET_STUDENT_SUCCESS = 'students/getStudentSuccess';
const GET_STUDENT_FAILURE = 'students/getStudentFailure';
const GET_ACHIEVEMENTS_REQUEST = 'students/getAchievementsRequest';
const GET_ACHIEVEMENTS_SUCCESS = 'students/getAchievementsSuccess';
const GET_ACHIEVEMENTS_FAILURE = 'students/getAchievementsFailure';
const RESET_ACHIEVEMENTS = 'students/resetAchievements';
const GET_RECENT_USERS = 'students/getRecentUsers';
const GET_RECENT_USERS_REQUEST = 'students/getRecentUsersRequest';
const GET_RECENT_USERS_SUCCESS = 'students/getRecentUsersSuccess';
const GET_RECENT_USERS_FAILURE = 'students/getRecentUsersFailure';
const UPDATE_MAIL_AUTHENTICATION_SUCCESS = 'students/updateMailAuthenticationSuccess';
const DELETE_STUDENT = 'students/delete';
const DELETE_STUDENT_REQUEST = 'students/deleteRequest';
const DELETE_STUDENT_SUCCESS = 'students/deleteSuccess';
const DELETE_STUDENT_FAILURE = 'students/deleteFailure';
// forwardに引数が渡されていたら、その数値を返す。引数なしで呼ばれたら-1を返す
export const forward = (step) => {
    return {
        step: step ? step : -1,
        type: FORWARD,
    };
};
export const back = () => {
    return {
        type: BACK,
    };
};
export const register = (info) => {
    return {
        payload: {
            info,
        },
        type: REGISTER,
    };
};
export const phoneRegister = (sms) => {
    return {
        payload: {
            sms,
        },
        type: PHONE_REGISTER,
    };
};
export const resetInfo = () => {
    return {
        type: RESET_INFO,
    };
};
export const clearError = () => {
    return {
        type: CLEAR_ERROR,
    };
};
export const clearOtherUser = () => {
    return {
        type: CLEAR_OTHER_USER,
    };
};
export const getTagsRequest = () => {
    return {
        type: GET_TAGS_REQUEST,
    };
};
export const getTagsSuccess = (tags) => {
    return {
        payload: {
            tags,
        },
        type: GET_TAGS_SUCCESS,
    };
};
export const getTagsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TAGS_FAILURE,
    };
};
export const getTags = () => {
    return (dispatch) => {
        dispatch(getTagsRequest());
        return axios
            .get(resolvePath.api('categories'))
            .then((response) => dispatch(getTagsSuccess(transformCategoryToTags('en')(response.data.categories))))
            .catch((error) => {
            dispatch(getTagsFailure(Response.error));
            throw error;
        });
    };
};
export const getPurposesRequest = () => {
    return {
        type: GET_PURPOSES_REQUEST,
    };
};
export const getPurposesSuccess = (purposes) => {
    return {
        payload: {
            purposes,
        },
        type: GET_PURPOSES_SUCCESS,
    };
};
export const getPurposesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PURPOSES_FAILURE,
    };
};
export const getPurposes = () => {
    return (dispatch) => {
        dispatch(getPurposesRequest());
        return axios
            .get(resolvePath.api('students/purposes'))
            .then((response) => dispatch(getPurposesSuccess(response.data)))
            .catch((error) => {
            dispatch(getPurposesFailure(error));
            throw error;
        });
    };
};
export const postMeRequest = () => {
    return {
        type: POST_ME_REQUEST,
    };
};
export const postMeSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: POST_ME_SUCCESS,
    };
};
export const postMeFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_ME_FAILURE,
    };
};
export const postMe = (student) => {
    return (dispatch) => {
        dispatch(postMeRequest());
        return axios
            .post(resolvePath.api('students'), student)
            .then((response) => {
            dispatch(postMeSuccess(response.data));
            if (response.data.auth_token) {
                localStorage.setItem(localStorageConstants.STUDENTS_AUTH_TOKEN_KEY, response.data.auth_token);
                localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
            }
        })
            .catch((error) => {
            dispatch(postMeFailure(error));
            throw error;
        });
    };
};
export const postSigninRequest = () => {
    return {
        type: POST_SIGNIN_REQUEST,
    };
};
export const postSigninSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: POST_SIGNIN_SUCCESS,
    };
};
export const postSigninFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_SIGNIN_FAILURE,
    };
};
export const postSignin = (signin) => {
    return (dispatch) => {
        dispatch(postSigninRequest());
        return axios
            .post(resolvePath.api('students/signin'), signin)
            .then((response) => {
            dispatch(postSigninSuccess(normalizeMyTagData('en')(response.data)));
            if (response.data.auth_token) {
                localStorage.setItem(localStorageConstants.STUDENTS_AUTH_TOKEN_KEY, response.data.auth_token);
                localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
                localStorage.setItem(localStorageConstants.USERS_EMAIL, response.data.email);
            }
        })
            .catch((error) => {
            dispatch(postSigninFailure(error));
            throw error;
        });
    };
};
export const getPkRequest = () => {
    return {
        type: GET_PK_REQUEST,
    };
};
export const getPkSuccess = (key) => {
    return {
        payload: {
            key,
        },
        type: GET_PK_SUCCESS,
    };
};
export const getPkFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PK_FAILURE,
    };
};
export const getPk = (authToken) => {
    return (dispatch) => {
        dispatch(getPkRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('issues/pk'), config)
            .then((response) => {
            dispatch(getPkSuccess(response.data));
            localStorage.setItem(localStorageConstants.STRIPE_PUBLIC_KEY, response.data);
        })
            .catch((error) => {
            dispatch(getPkFailure(error));
            throw error;
        });
    };
};
export const getPackagesRequest = () => {
    return {
        type: GET_PACKAGES_REQUEST,
    };
};
export const getPackagesSuccess = (key) => {
    return {
        payload: {
            key,
        },
        type: GET_PACKAGES_SUCCESS,
    };
};
export const getPackagesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PACKAGES_FAILURE,
    };
};
export const getPackages = (authToken) => {
    return (dispatch) => {
        dispatch(getPackagesRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('issues/packages'), config)
            .then((response) => {
            dispatch(getPackagesSuccess(response.data));
            localStorage.setItem(localStorageConstants.PACKAGE_PRICE, response.data.discounted_price);
            localStorage.setItem(localStorageConstants.PACKAGE_ID, response.data.id);
        })
            .catch((error) => {
            dispatch(getPackagesFailure(error));
            throw error;
        });
    };
};
export const getMeRequest = () => {
    return {
        type: GET_ME_REQUEST,
    };
};
export const getMeSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: GET_ME_SUCCESS,
    };
};
export const getMeFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ME_FAILURE,
    };
};
export const getMe = (authToken) => {
    return (dispatch) => {
        dispatch(getMeRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('students/me'), config)
            .then((response) => {
            dispatch(getMeSuccess(normalizeMyTagData('en')(response.data)));
            localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
        })
            .catch((error) => {
            dispatch(getMeFailure(error));
            throw error;
        });
    };
};
export const patchMeRequest = () => {
    return {
        type: PATCH_ME_REQUEST,
    };
};
export const patchMeSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: PATCH_ME_SUCCESS,
    };
};
export const patchMeFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_ME_FAILURE,
    };
};
export const patchMe = (authToken, changes, redirect) => (dispatch) => {
    dispatch(patchMeRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const redirectLink = redirect ? redirect : 'mypage';
    return axios
        .patch(resolvePath.api('students/me'), changes, config)
        .then((response) => {
        dispatch(patchMeSuccess(normalizeMyTagData('en')(response.data)));
        localStorage.setItem(localStorageConstants.USERS_EMAIL, changes.email);
        dispatch(push(resolvePath.page('students', redirectLink)));
    })
        .catch((error) => {
        dispatch(patchMeFailure(error));
        throw error;
    });
};
export const postPhoneAuthenticationRequest = () => {
    return {
        type: POST_PHONE_AUTHENTICATION_REQUEST,
    };
};
export const postPhoneAuthenticationSuccess = (sms) => {
    return {
        payload: {
            sms,
        },
        type: POST_PHONE_AUTHENTICATION_SUCCESS,
    };
};
export const postPhoneAuthentication = (request) => (dispatch) => {
    dispatch(postPhoneAuthenticationRequest());
    return axios
        .post(resolvePath.api('phone_authentication'), request)
        .then((response) => {
        dispatch(postPhoneAuthenticationSuccess(response.data));
    })
        .catch((error) => {
        dispatch(postValidateFailure(error));
        throw error;
    });
};
export const postPhoneCodeValidationRequest = () => {
    return {
        type: POST_PHONE_CODE_VALIDATION_REQUEST,
    };
};
export const postPhoneCodeValidationSuccess = (sms) => {
    return {
        payload: {
            sms,
        },
        type: POST_PHONE_CODE_VALIDATION_SUCCESS,
    };
};
export const postPhoneCodeValidation = (request) => (dispatch) => {
    dispatch(postPhoneCodeValidationRequest());
    return axios
        .patch(resolvePath.api('phone_authentication'), request)
        .then((response) => dispatch(postPhoneCodeValidationSuccess(response.data)))
        .catch((error) => {
        dispatch(postValidateFailure(error));
        throw error;
    });
};
export const postValidateRequest = () => {
    return {
        type: POST_VALIDATE_REQUEST,
    };
};
export const postValidateSuccess = (validation) => {
    return {
        payload: {
            validation,
        },
        type: POST_VALIDATE_SUCCESS,
    };
};
export const postValidateFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_VALIDATE_FAILURE,
    };
};
export const postValidate = (request) => (dispatch) => {
    dispatch(postValidateRequest());
    return axios
        .post(resolvePath.api('students/validate'), request)
        .then((response) => dispatch(postValidateSuccess(response.data)))
        .catch((error) => {
        dispatch(postValidateFailure(error));
        throw error;
    });
};
export const deleteSignoutRequest = () => {
    return {
        type: DELETE_SIGNOUT_REQUEST,
    };
};
export const deleteSignoutSuccess = () => {
    return {
        type: DELETE_SIGNOUT_SUCCESS,
    };
};
export const deleteSignoutFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_SIGNOUT_FAILURE,
    };
};
export const deleteSignout = (authToken) => (dispatch) => {
    dispatch(deleteSignoutRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .delete(resolvePath.api('students/signout'), config)
        .then(() => dispatch(deleteSignoutSuccess()))
        .catch((error) => {
        dispatch(deleteSignoutFailure(error));
        throw error;
    });
};
export const postPasswordRequest = () => {
    return {
        type: POST_PASSWORD_REQUEST,
    };
};
export const postPasswordSuccess = () => {
    return {
        type: POST_PASSWORD_SUCCESS,
    };
};
export const postPasswordFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_PASSWORD_FAILURE,
    };
};
export const postPassword = (email) => (dispatch) => {
    dispatch(postPasswordRequest());
    const request = {
        email,
    };
    return axios
        .post(resolvePath.api('students/password'), request)
        .then(() => dispatch(postPasswordSuccess()))
        .catch((error) => {
        dispatch(postPasswordFailure(error));
        throw error;
    });
};
export const postIssueRequest = () => {
    return {
        type: POST_ISSUE_REQUEST,
    };
};
export const postIssueSuccess = () => {
    return {
        type: POST_ISSUE_SUCCESS,
    };
};
export const postIssueFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_ISSUE_FAILURE,
    };
};
export const postIssue = (paymentData, authToken) => (dispatch) => {
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    dispatch(postIssueRequest());
    return axios
        .post(resolvePath.api('students/charge'), paymentData, config)
        .then(() => dispatch(postIssueSuccess()))
        .catch((error) => {
        dispatch(postIssueFailure(error));
        throw error;
    });
};
export const patchPasswordRequest = () => {
    return {
        type: PATCH_PASSWORD_REQUEST,
    };
};
export const patchPasswordSuccess = () => {
    return {
        type: PATCH_PASSWORD_SUCCESS,
    };
};
export const patchPasswordFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_PASSWORD_FAILURE,
    };
};
export const patchPassword = (token, password) => (dispatch) => {
    dispatch(patchPasswordRequest());
    const request = {
        password,
        token,
    };
    return axios
        .patch(resolvePath.api('students/password'), request)
        .then(() => dispatch(patchPasswordSuccess()))
        .catch((error) => {
        dispatch(patchPasswordFailure(error));
        throw error;
    });
};
export const getStudentRequest = () => {
    return {
        type: GET_STUDENT_REQUEST,
    };
};
export const getStudentSuccess = (otherUser) => {
    return {
        payload: {
            otherUser,
        },
        type: GET_STUDENT_SUCCESS,
    };
};
export const getStudentFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_STUDENT_FAILURE,
    };
};
export const getStudent = (authToken, studentId, selfId) => {
    return (dispatch) => {
        dispatch(getStudentRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        const getStudentDataPromise = axios.get(resolvePath.api(`students/${studentId}`), config);
        const getStudentMemoPromise = axios.get(resolvePath.api(`students/${studentId}/memos?${qs.stringify({ selfId })}`), config);
        return Promise.all([getStudentDataPromise, getStudentMemoPromise])
            .then(([studentDataResponse, studentMemoResponse]) => {
            const otherUserData = Object.assign(Object.assign({}, studentDataResponse.data), { memos: studentMemoResponse.data });
            dispatch(getStudentSuccess(otherUserData));
        })
            .catch((error) => {
            dispatch(getStudentFailure(error));
            throw error;
        });
    };
};
export const getAchievementsRequest = () => {
    return {
        type: GET_ACHIEVEMENTS_REQUEST,
    };
};
export const getAchievementsSuccess = (achievements) => {
    return {
        payload: {
            achievements,
        },
        type: GET_ACHIEVEMENTS_SUCCESS,
    };
};
export const getAchievementstFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ACHIEVEMENTS_FAILURE,
    };
};
export const getAchievements = (authToken, userId) => {
    return (dispatch) => {
        dispatch(getAchievementsRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: { user_id: userId },
        };
        return axios
            .get(resolvePath.api('students/achievements'), config)
            .then((response) => {
            dispatch(getAchievementsSuccess(response.data));
        })
            .catch((error) => {
            dispatch(getAchievementstFailure(error));
            throw error;
        });
    };
};
export const resetAchievements = () => {
    return {
        type: RESET_ACHIEVEMENTS,
    };
};
export const getRecentlyRequest = () => {
    return {
        type: GET_RECENT_USERS_REQUEST,
    };
};
export const getRecentUsersSuccess = (users) => {
    return {
        payload: {
            users,
        },
        type: GET_RECENT_USERS_SUCCESS,
    };
};
export const getRecentUsersFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_RECENT_USERS_FAILURE,
    };
};
export const getRecentUsers = (authToken) => {
    const loadRecentUsers = (dispatch) => {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('students/recently'), config)
            .then((response) => dispatch(getRecentUsersSuccess(response.data ? response.data.data : [])))
            .catch((error) => {
            dispatch(getRecentUsersFailure(error));
            throw new Error();
        });
    };
    loadRecentUsers(store.dispatch);
    return {
        type: GET_RECENT_USERS,
    };
};
export const updateMailAuthenticationSuccess = () => {
    return {
        type: UPDATE_MAIL_AUTHENTICATION_SUCCESS,
    };
};
export const deleteStudentRequest = () => {
    return {
        type: DELETE_STUDENT_REQUEST,
    };
};
export const deleteStudentSuccess = () => {
    return {
        type: DELETE_STUDENT_SUCCESS,
    };
};
export const deleteStudentFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_STUDENT_FAILURE,
    };
};
export const deleteStudent = (authToken) => {
    const deleteCurrentStudent = (dispatch) => {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .delete(resolvePath.api('students/me'), config)
            .then(() => dispatch(deleteStudentSuccess()))
            .catch((error) => {
            dispatch(deleteStudentFailure(error));
            throw new Error('An error occured while deleting the account.');
        });
    };
    deleteCurrentStudent(store.dispatch);
    return {
        type: DELETE_STUDENT,
    };
};
const initialInfoState = {
    code_array: ['N', 'N', 'N', 'N', 'N', 'N'],
    conversation_level: 0,
    country: '',
    current_password: '',
    custom_gender: '',
    desired_condition: 0,
    email: '',
    gender: 0,
    introduce: '',
    level: 0,
    name: '',
    name_ja: '',
    nationality: '',
    password: '',
    picture: '',
    prefecture: 0,
    preferred_name: 1,
    purposes: [],
    tags: [],
    timezone: '',
    is_trial: false,
    employment_hope: 0,
};
const initialMeState = {
    absence: 0,
    auth_token: '',
    birthday: '',
    conversation_level: 0,
    conversations: [],
    country: '',
    custom_gender: '',
    desired_condition: 0,
    email: '',
    evaluate: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
    },
    employment_hope: 0,
    grade: null,
    id: 0,
    introduce: '',
    lateness: 0,
    level: 0,
    location: '',
    plus_user: false,
    name: '',
    name_ja: '',
    nationality: '',
    organization_device: null,
    organization_sections: [],
    organizations: [],
    picture_url: '',
    prefecture: 0,
    preferred_name: 1,
    purposes: [],
    rated_conversation_level: null,
    sex: 0,
    tags: [],
    timezone: '',
    type: '',
    username: '',
    web_socket_token: '',
    subscribing: false,
    confirmed: false,
    unConfirmedEmail: '',
};
const initialSmsState = {
    code: '',
    code_array: [''],
    country: '',
    phone_number: '',
};
const initialAchievementsState = {
    running_days: 0,
    week_days_conversation_time: [0, 0, 0, 0, 0, 0, 0],
    stats: {
        weekly: {
            total_time: 0,
            conversation_count: 0,
            partner_count: 0,
            recently_partners: [],
        },
        monthly: {
            total_time: 0,
            conversation_count: 0,
            partner_count: 0,
            recently_partners: [],
        },
        total: {
            total_time: 0,
            conversation_count: 0,
            partner_count: 0,
            recently_partners: [],
        },
    },
};
const initialState = {
    error: null,
    info: initialInfoState,
    isFetching: false,
    isPasswordRenewed: false,
    me: initialMeState,
    otherUser: null,
    purposes: [],
    sentPasswordResetRequest: false,
    sms: initialSmsState,
    step: 1,
    tags: [],
    validation: null,
    achievements: initialAchievementsState,
    recentlyUsers: [],
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            if (action.step < 0) {
                return Object.assign(Object.assign({}, state), { step: state.step < 7 ? state.step + 1 : state.step });
            }
            else {
                return Object.assign(Object.assign({}, state), { step: action.step < 7 ? action.step : 7 });
            }
        }
        case BACK: {
            return Object.assign(Object.assign({}, state), { step: state.step > 1 ? state.step - 1 : state.step });
        }
        case REGISTER: {
            return Object.assign(Object.assign({}, state), { error: null, info: Object.assign({}, action.payload.info) });
        }
        case RESET_INFO: {
            return Object.assign(Object.assign({}, state), { info: Object.assign({}, initialInfoState), step: 1 });
        }
        case CLEAR_ERROR: {
            return Object.assign(Object.assign({}, state), { error: null });
        }
        case CLEAR_OTHER_USER: {
            return Object.assign(Object.assign({}, state), { otherUser: null });
        }
        case GET_TAGS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_TAGS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { tags: action.payload.tags, isFetching: false });
        }
        case GET_TAGS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_PURPOSES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_PURPOSES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, purposes: action.payload.purposes });
        }
        case GET_PURPOSES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_ME_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_ME_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case POST_ME_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_SIGNIN_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_SIGNIN_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case POST_SIGNIN_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_ME_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ME_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case GET_ME_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case PATCH_ME_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case PATCH_ME_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case PATCH_ME_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_VALIDATE_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_VALIDATE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, validation: action.payload.validation });
        }
        case POST_VALIDATE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case DELETE_SIGNOUT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case DELETE_SIGNOUT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false });
        }
        case DELETE_SIGNOUT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_PASSWORD_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_PASSWORD_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, sentPasswordResetRequest: true });
        }
        case POST_PASSWORD_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case PATCH_PASSWORD_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case PATCH_PASSWORD_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, isPasswordRenewed: true });
        }
        case PATCH_PASSWORD_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_STUDENT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_STUDENT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, otherUser: Object.assign({}, action.payload.otherUser) });
        }
        case GET_STUDENT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_ACHIEVEMENTS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ACHIEVEMENTS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, achievements: action.payload.achievements });
        }
        case GET_ACHIEVEMENTS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case RESET_ACHIEVEMENTS: {
            return Object.assign(Object.assign({}, state), { achievements: initialAchievementsState });
        }
        case GET_RECENT_USERS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_RECENT_USERS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, recentlyUsers: action.payload.users });
        }
        case GET_RECENT_USERS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case UPDATE_MAIL_AUTHENTICATION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { me: Object.assign(Object.assign({}, state.me), { confirmed: true, unConfirmedEmail: '' }) });
        }
        case DELETE_STUDENT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case DELETE_STUDENT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false });
        }
        case DELETE_STUDENT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
